import { TSellerNotifyChannel } from 'models/orders'

export const sellerNotifyChannelLabels: Record<TSellerNotifyChannel, string> = {
  sms: 'SMS',
  push: 'Push',
  max: 'MAX-бот',
  telegram: 'Telegram-бот',
  email: 'Email'
}

export const sellerNotifyChannelColors: Record<TSellerNotifyChannel, string> = {
  sms: 'blue',
  push: 'purple',
  max: 'geekblue',
  telegram: 'cyan',
  email: 'default'
}

// Бэкенд отдаёт каналы в произвольном порядке, показываем всегда в одном
export const sellerNotifyChannelOrder = Object.keys(sellerNotifyChannelLabels) as TSellerNotifyChannel[]
